import { useRef, useState } from 'react';
import { modulosWeb } from './modulos-web';
import { podeNoWorkspace, useSessao } from './sessao';

/**
 * Lista de 30/10 (B), itens 24 e 25: a frase no alto de um cadastro ("Personalize o formulário de cadastro de empresa. Criar
 * novos campos"); o link abre o pop-up de criar o campo (o mesmo formulário da página de campos) sem sair da tela. O campo novo
 * entra no fim do cadastro, que lê as definições de novo. Só aparece para quem cria campo (`configuracoes.campos`, a mesma
 * permissão do botão "Criar campo" da página de campos e do POST); sem o módulo Configurações, nada.
 */
export function CriarCamposDica({ entidade, frase, link, abaFixa }: { entidade: string; frase: string; link: string; abaFixa?: { campo: string; valor: string; aba: string } }) {
  const s = useSessao();
  const [aberto, setAberto] = useState(false);
  const botao = useRef<HTMLButtonElement>(null);
  const Criar = modulosWeb.find((m) => m.criarCampo)?.criarCampo;
  if (!Criar || !podeNoWorkspace(s, 'configuracoes.campos')) return null;
  return (
    <>
      <p className="mb-4 rounded-lg border border-borda bg-sup-2 px-3 py-2 text-sm text-tinta-2" data-dica-campos="">
        {frase}{' '}
        <button ref={botao} type="button" className="min-h-8 font-medium text-acento-forte underline-offset-2 hover:underline" aria-haspopup="dialog" onClick={() => setAberto(true)} data-criar-novos-campos="">
          {link}
        </button>
      </p>
      <Criar
        entidade={entidade}
        abaFixa={abaFixa}
        aberto={aberto}
        aoFechar={() => {
          setAberto(false);
          requestAnimationFrame(() => botao.current?.focus());
        }}
      />
    </>
  );
}
